const steps = {
  request: 'request',
  cancelDeflection: 'cancel-deflection',
  confirmation: 'confirmation',
  reasonMultipleChoiceContent: 'reason-multiple-choice-content',
  reasonCheckboxContent: 'reason-checkbox-content',
  reasonShortAnswerContent: 'reason-short-answer-content',
};

export type StepType = typeof steps[keyof typeof steps];

export default steps;
